import React from 'react'

function ProcessFour() {
  return (
    <div>
      <section className="process-four">
        <div className="container">
          <div className="process-four-title-box">
            <div
              className="section-three-title wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="100ms"
            >
              <div className="section-three-title-title text-center">
                <h2>Increase Web Leads Traffic In 3 Ways</h2>
              </div>
            </div>
            <div
              className="section-three-details text-center wow fadeInUp animated"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <p>
                Digital marketing &amp; advertising approach focuses on
                capturing the essential
              </p>
            </div>
          </div>
          <div className="process-four-detail-box">
            <div className="row">
              <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <div
                  className="process-four-single-box process-four-single-box-one wow fadeInRight animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="process-four-single-tag">
                    <span>01</span>
                  </div>
                  <h5>Brainstorming and Creative ideas &amp; Research</h5>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <div
                  className="process-four-single-box process-four-single-box-two wow fadeInRight animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="process-four-single-tag">
                    <span>02</span>
                  </div>
                  <h5>Fully-Automated Keyword &amp; Content Grouping</h5>
                </div>
              </div>
              <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <div
                  className="process-four-single-box process-four-single-box-three wow fadeInRight animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="500ms"
                >
                  <div className="process-four-single-tag">
                    <span>03</span>
                  </div>
                  <h5>Building the strategy to boost Your Product Sales</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default ProcessFour
